@import "../../../../styles/base";

.Link {
  background: none;
  border-radius: 0;
  border: none;
  margin: 0;
  padding: 0;
  font-weight: normal;
  text-decoration: underline;
  transition: color 0.15s ease-in-out;
  outline: none;
  font-size: inherit;

  &[target="_blank"]::after {
    display: none;
  }

  &:hover,
  &:focus {
    background: none;
    color: inherit;
  }

  &.quiet {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &:focus-visible {
    outline: none;
    box-shadow: $focus-shadow;
  }

  &:not(:focus-visible):focus {
    outline: none;
  }
}

.primary {
  color: $ds-violet-900;

  &.overBg {
    color: $ds-violet-300;
  }
}

.secondary {
  color: $ds-violet-500;

  &.overBg {
    color: $ds-neutral-100;
  }
}
